export const DEFAULT_INFO = {}
export const DEFAULT_LOGGED_IN = false

export default {
  info: DEFAULT_INFO,
  loggedIn: DEFAULT_LOGGED_IN
}
